'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withSpacing;

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _shallowEqual = require('fbjs/lib/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _getTheme = require('./getTheme');

var _getTheme2 = _interopRequireDefault(_getTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var spacingProps = {
  p: ['padding'],
  m: ['margin'],
  pt: ['paddingTop'],
  pr: ['paddingRight'],
  pb: ['paddingBottom'],
  pl: ['paddingLeft'],
  mt: ['marginTop'],
  mr: ['marginRight'],
  mb: ['marginBottom'],
  ml: ['marginLeft'],
  py: ['paddingTop', 'paddingBottom'],
  px: ['paddingLeft', 'paddingRight'],
  my: ['marginTop', 'marginBottom'],
  mx: ['marginLeft', 'marginRight']
};

var propKeys = Object.keys(spacingProps);
var pick = function pick(obj) {
  return propKeys.reduce(function (acc, key) {
    return _extends({}, acc, _defineProperty({}, key, obj[key]));
  }, {});
};

var withSpacingArgs = propKeys.map(function (prop) {
  return function (props, theme) {
    return (0, _breakpoints2.default)(props[prop], theme, function (arg) {
      return arg && spacingProps[prop].reduce(function (acc, cssProp) {
        return _extends({}, acc, _defineProperty({}, cssProp, arg));
      }, {});
    });
  };
});

var getSpacingStyles = function getSpacingStyles(props, theme) {
  return withSpacingArgs.reduce(function (acc, fn) {
    return _extends({}, acc, fn(props, theme));
  }, {}) // noop needed otherwise glamor throws a cache-miss error...
  ;
};

function withSpacing(Component) {
  return (0, _glamorous2.default)(Component, {
    shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps) {
      return !(0, _shallowEqual2.default)(pick(props), pick(nextProps));
    }
  })(function (props) {
    return getSpacingStyles(props, (0, _getTheme2.default)(props));
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/glamorous-grid/lib/withSpacing.js
// module id = ./node_modules/glamorous-grid/lib/withSpacing.js
// module chunks = 2345137460201621000 7489246917808536000 9249036036638527000